<div *ngIf="field != null && field != undefined">
  <div *ngIf="isTaskDescriptionField  else commentField" class="form-group">
    <div *ngIf="!descriptorLoading" [id]="gpFieldIdPrefix + field.id" class="p-b-md">
      <div *ngIf="field.value"
           [innerHtml]="(field.value | translate | translateAndFormatVariables: field.taskVariables: (trigger$|async)) | bypassSecurityTrustHtml"></div>
    </div>
    <div *ngIf="taskDescriptionType !== DEFAULT_TASK">
      <div [ngSwitch]="taskDescriptionType">
        <div *ngSwitchCase="GP_EMPLOYEE_FORM_DESCRIPTOR_TASK" class="form-group">
          <gp-form-descriptor-element
            [cliRegId]="cliRegId"
            [requestVariable]="requestVariable"
            [contractId]="contractId"
            [taskDefinitionKey]="taskDefinitionKey"
            [taskDescriptionField]="field"
            (errorTriggered)="emitError($event)"
            (loadingEnded)="loadingEnd($event)"
            [taskDescriptionType]="taskDescriptionType">
          </gp-form-descriptor-element>
        </div>
        <div *ngSwitchCase="CLAIM_TASK" class="form-group">
          <gp-claim-element
            [cliRegId]="cliRegId"
            [contractId]="contractId"
            [requestVariable]="requestVariable"
            (requestUpdate)="onRequestUpdate($event)">
          </gp-claim-element>
        </div>
      </div>
    </div>
  </div>
  <ng-template #commentField class="form-group">
    <div *ngIf="!descriptorLoading">
      <label class="control-label">{{ FORM_TRANSLATE_PREFIX + field.id | translate }}</label>
      <span class="marker" *ngIf="field.required">*</span>
      <textarea style="min-height: 60px;"
                [id]="gpFieldIdPrefix + field.id"
                [(ngModel)]="field.value"
                class="form-control"
                [placeholder]="field.placeholder ? (FORM_PLACEHOLDER_TRANSLATE_PREFIX + field.placeholder | translate) : ''"
                [required]="field.required"
                [readOnly]="field.readOnly"
                [minlength]="field.params?.minLength || ''"
                [maxlength]="field.params?.maxLength || ''"
                [pattern]="field.params?.regexPattern || ''">
      </textarea>
    </div>
  </ng-template>

</div>
